import { useQueries } from "@tanstack/react-query";
import { authService } from "../../../services/Services";
import { BoundingBox } from "../../../types/TrackedObject";
import { apiClient } from "../../../services/Services";
import { createUrlWithQuery } from "../../../hooks/utils";

interface ApiResponse {
    data: BoundingBox[];
    meta: Record<string, any>;
}

export const useFetchObjectDetections = (
    objectIds: string[],
    enabled: boolean,
) => {
    const token = authService.getIdentityToken();

    const detectionQueries = useQueries({
        queries: objectIds.map((id) => ({
            queryKey: ["object", id, "detections"],
            endpoint: `/objects/${id}/detections`,
            enabled: !!token && !!id && enabled,
            queryFn: async ({ signal }) => {
                const response = await apiClient
                    .get<ApiResponse>(
                        createUrlWithQuery(`objects/${id}/detections`, {}),
                    )
                    .then((res) => res.data);

                return response;
            },
        })),
    });

    // Build a map from objectId to bounding box array
    const dataMap: Record<string, BoundingBox[] | undefined> = {};
    objectIds.forEach((id, idx) => {
        dataMap[id] = detectionQueries[idx]?.data;
    });

    return {
        data: dataMap,
        ...detectionQueries,
    };
};
